"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ChatMessageDto_1 = require("./ChatMessageDto");
const immutable_1 = require("immutable");
const CommonBaseError_1 = require("../../Common/CommonBaseError");
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
class ChatDto {
    constructor(chatDto) {
        this.id = "";
        this.tempId = "";
        this.name = "";
        this.tags = [];
        this.participants = new Set();
        this.participantReadCounts = new Map();
        this.endedFor = new Set();
        this.messages = [];
        this.createdFrom = 0;
        this.totalChatMessageCount = 0;
        if (chatDto) {
            this.id = chatDto.id || this.id;
            this.tempId = chatDto.tempId || this.tempId;
            this.name = chatDto.name || this.name;
            this.tags = chatDto.tags || this.tags;
            this.participants = chatDto.participants ?
                new Set(chatDto.participants instanceof Array ?
                    TypeScriptUtils_1.iterableObjToTypedSet(chatDto.participants) : chatDto.participants)
                : this.participants;
            this.participantReadCounts = chatDto.participantReadCounts ?
                new Map(chatDto.participantReadCounts instanceof Map ?
                    chatDto.participantReadCounts : TypeScriptUtils_1.objectToStringKeyTypedValueMap(chatDto.participantReadCounts))
                : this.participantReadCounts;
            this.endedFor = chatDto.endedFor ?
                new Set(chatDto.endedFor instanceof Array ?
                    TypeScriptUtils_1.iterableObjToTypedSet(chatDto.endedFor) : chatDto.endedFor)
                : this.endedFor;
            this.messages = chatDto.messages ?
                TypeScriptUtils_1.iterableObjToTypedArray(chatDto.messages, ChatMessageDto_1.ChatMessageDto)
                : this.messages;
            this.createdFrom = chatDto.createdFrom || this.createdFrom;
            this.totalChatMessageCount = chatDto.totalChatMessageCount || this.totalChatMessageCount;
        }
    }
    toString() {
        return JSON.stringify(this);
    }
    toJSON() {
        const temp = new TempChatDto(this);
        return temp;
    }
    firstParticipantExcludeSpeakOf(speakerUserName) {
        if (!speakerUserName)
            throw new ChatDtoError("speakerUserName should not be empty.");
        return immutable_1.List(this.participants)
            .filter(participant => participant !== speakerUserName)
            .first();
    }
    unreadMessageCount(participant) {
        const participantReadCount = this.participantReadCounts.get(participant);
        if (participantReadCount === undefined)
            return 0;
        const unreadMessageCount = this.totalChatMessageCount - participantReadCount;
        return (unreadMessageCount >= 0) ? unreadMessageCount : 0;
    }
    lastChatMessage() {
        const latestCmDto = immutable_1.List(this.messages).last();
        return latestCmDto ? latestCmDto : ChatMessageDto_1.ChatMessageDto.INVALID_CHAT_MESSAGE;
    }
}
ChatDto.INVALID_CHAT = new ChatDto();
exports.ChatDto = ChatDto;
class TempChatDto {
    constructor(chatDto) {
        this.id = chatDto.id;
        this.tempId = chatDto.tempId;
        this.name = chatDto.name;
        this.tags = chatDto.tags;
        this.participants = immutable_1.Set(chatDto.participants);
        this.participantReadCounts = immutable_1.Map(chatDto.participantReadCounts);
        this.endedFor = immutable_1.Set(chatDto.endedFor);
        this.messages = chatDto.messages;
        this.createdFrom = chatDto.createdFrom;
        this.totalChatMessageCount = chatDto.totalChatMessageCount;
    }
}
exports.TempChatDto = TempChatDto;
exports.ChatDtoErrorName = "ChatDtoError";
class ChatDtoError extends CommonBaseError_1.CommonBaseError {
}
exports.ChatDtoError = ChatDtoError;
//# sourceMappingURL=ChatDto.js.map